import {DealsTag, HomepageLaneType} from "@irati/types"

export const getLaneHeader = (type: HomepageLaneType, tag?: DealsTag, customHeaderName?: string) => {
  switch (type) {
    case HomepageLaneType.New:
      return "perks.containers.homepage.newPerks"
    case HomepageLaneType.Trending:
      return "perks.containers.homepage.trending"
    case HomepageLaneType.Other:
      return customHeaderName
    case HomepageLaneType.Tag:
      return tag ? tag.name : null
    default:
      return null
  }
}
